import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import * as Sentry from '@sentry/react'

const RoutesListener = (props) => {
  const { currentUser } = useSelector((state) => state.auth)
  const history = useHistory()

  useEffect(() => {
    // Set user context for Sentry
    if (currentUser) {
      Sentry.setUser({
        id: currentUser.id,
        email: currentUser.email,
        username: currentUser.fullName
      })
    } else {
      Sentry.setUser(null)
    }

    // Listen for location changes
    const unlisten = history.listen((location, action) => {
      // Track page views in Sentry
      Sentry.addBreadcrumb({
        category: 'navigation',
        message: `Navigated to ${location.pathname}`,
        level: 'info'
      })
    })

    return () => {
      unlisten()
    }
  }, [currentUser, history])

  return props.children
}

export default RoutesListener
